import React from "react";
import { CircularProgress, Grid } from "@mui/material";
import EditTable from "../../../components/Components/MaterialInwardTable";
import { useQuery } from "react-query";
import { getMaterialInwardList } from "../mutations/TransactionsMutation";
import Loader from "../../../components/Components/Loader";

function MaterialInward() {
  const currentTimestamp = Date.now();

  const currentDate = new Date(currentTimestamp);

  const formattedDate = currentDate.toISOString().slice(0, 10);

  const { data: materialInwardData, isLoading } = useQuery(
    "material-inward-transactions",
    () => getMaterialInwardList(formattedDate),
    { refetchOnMount: true }
  );

  if (isLoading) return <Loader />;

  return (
    <Grid container justifyContent={"center"}>
      <Grid item textAlign={"center"}>
        <h4>Material Inward Transactions</h4>
      </Grid>
      <Grid item xs={12}>
        <EditTable tableData={materialInwardData ?? []} />
      </Grid>
    </Grid>
  );
}

export default MaterialInward;
